// extracted by mini-css-extract-plugin
export default {"spinnerLottieBox":"SpinnerLottie-module__spinnerLottieBox__uvp9T"};